/**
 * Configuration pour la gestion des données d'enrichissement
 * Configuration uniforme sur toutes les plateformes pour faciliter le debug
 */

export const DONNEES_ENRICHISSEMENT_CONFIG = {
  // Mode fixe : whitelist avec tous les champs des formulaires
  mode: 'whitelist',
  
  // Liste blanche : tous les champs utilisés dans les formulaires @forms/
  // Extraits automatiquement des formulaires dans /pages/posts/forms/
  allowedFields: new Set([
    // Champs d'accessibilité et confort
    'acces_handicapes', 'acces_internet_haut_debit', 'acces_wifi', 'alarme_habitation',
    'ascenseur', 'cable_tv', 'climatise', 'concierge', 'digicode', 'fibre_optique',
    'gardien', 'interphone', 'telesurveille', 'tv', 'videophone', 'videosurveillance',
    
    // Champs d'accession et défiscalisation
    'accession_libre', 'accession_maitrisee', 'bail_reel_solidaire', 'compatible_psla',
    'compatible_ptz_plus', 'defisc_ehpad', 'defisc_loi_censi_bouvard', 'defisc_loi_demessine',
    'defisc_loi_duflot', 'defisc_loi_girardin_paul', 'defisc_loi_malraux', 'defisc_loi_mh',
    'defisc_loi_pinel', 'defisc_loi_pinel_outre_mer', 'defisc_loi_pinel_plus',
    'defisc_nue_propriete_demembrement', 'defisc_regime_scpi', 'defisc_statut_lmnp',
    'defisc_statut_lmp', 'defisc_tva_5_virgule_5_pourcent', 'defisc_tva_7_pourcent',
    'defisc_zone_anru', 'habitat_participatif', 'organisme_foncier_solidaire', 'pret_locatif_social',
    
    // Informations générales de l'annonce
    'adresse2', 'advertiser', 'afficher_prix', 'ca', 'code_postal', 'code_postal_reel',
    'devise_iso_4217', 'id', 'nom_voie', 'numero_voie', 'reference', 'texte', 'texte_resume',
    'titre', 'typeObjet', 'typeOffre', 'url_annonce_sur_site_annonceur', 'ville', 'ville_reelle',
    
    // DPE et données énergétiques
    'altitude', 'annee_indice_prix_energies', 'date_indice_prix_energies', 'dpe_date_realisation',
    'dpe_etiquette_conso', 'dpe_etiquette_ges', 'dpe_etiquette_seuil', 'dpe_valeur_conso',
    'dpe_valeur_ges', 'dpe_vierge', 'montant_depenses_energies_estime', 'montant_depenses_energies_max',
    'montant_depenses_energies_min', 'soumis_dpe', 'zone_georisque',
    'isolation_thermique_classe', 'isolation_thermique_valeur', 'panneaux_solaires',
    
    // Caractéristiques du bien - surfaces
    'surface_activite', 'surface_balcon', 'surface_bureaux', 'surface_carrez', 'surface_cave',
    'surface_commerciale', 'surface_divisible', 'surface_divisible_minimum', 'surface_habitable',
    'surface_jardin', 'surface_max', 'surface_min', 'surface_salle_a_manger', 'surface_sejour',
    'surface_stationnement', 'surface_terrain', 'surface_terrain_a_batir', 'surface_utile',
    'terrasse_surface',
    
    // Caractéristiques du bien - nombres
    'nb_balcons', 'nb_bien', 'nb_biens_disponibles', 'nb_garages', 'nb_parkings',
    'nb_pieces_logement', 'nb_place', 'nb_salles_d_eau', 'nb_salles_de_bain', 'nb_wc',
    'nombre_de_chambres', 'nombre_etages', 'nombre_niveaux',
    
    // Caractéristiques extérieures
    'avec_jardin', 'avec_pente', 'avec_toit_terrasse', 'avec_vis_a_vis', 'balcon', 'belle_vue',
    'constructible', 'cos', 'environnement', 'espaces_verts', 'est_calme', 'exposition',
    'largeur_terrain', 'largeur_terrain_a_batir', 'longueur_terrain', 'longueur_terrain_a_batir',
    'lotissement', 'obligation_debroussaillement', 'pieds_dans_eau', 'piscine', 'piscine_type',
    'terrain_piscinable', 'terrasse', 'viabilise', 'vis_a_vis', 'vue_sur_mer',
    
    // Proximité et localisation
    'proche_aeroport', 'proche_bus', 'proche_centre_commercial', 'proche_centre_ville',
    'proche_college', 'proche_commerces', 'proche_creche', 'proche_ecole_primaire',
    'proche_gare', 'proche_lycee', 'proche_metro', 'proche_parking', 'proche_sortie_autoroute',
    'proche_tram', 'proche_universite', 'ecoles_a_proximitees', 'eco_quartier',
    
    // Équipements et aménagements
    'cave', 'cheminee', 'coin_bureau', 'degagement', 'dressing', 'duplex', 'grenier',
    'local_velos', 'loggia', 'placards_integres', 'poele_a_bois', 'porte_blindee',
    'possede_box', 'possede_cajibi', 'possede_parking', 'salle_a_manger', 'sejour',
    'systeme_extraction_fumee', 'systeme_incendie', 'veranda', 'vigik', 'wc_independant',
    
    // Équipements de cuisine/électroménager
    'equipe_cafetiere', 'equipe_congelateur', 'equipe_fer_repasser', 'equipe_four',
    'equipe_grille_pain', 'equipe_lave_linge', 'equipe_lave_vaisselle', 'equipe_microondes',
    'equipements', 'type_cuisine',
    
    // Chauffage et distribution
    'chauffage_energie', 'chauffage_type', 'eau_chaude_distribution',
    
    // Construction et architecture
    'annee_construction', 'annee_renovation', 'bioconstruction', 'est_adapte_pmr',
    'est_maison_groupee', 'etage', 'facade_construction_max', 'hauteur_maximum',
    'mitoyennete', 'recent', 'residence_type', 'revetement_sol_principal', 'shon',
    'standing', 'style_construction', 'toiture', 'type_construction', 'type_livraison',
    'vitrages', 'volets_roulants_electriques',
    
    // Garage et stationnement
    'garage', 'garage_emplacement', 'type_stationnement',
    
    // Labels et certifications
    'label_acermi', 'label_bbc', 'label_biodivercity', 'label_biosource_niveau_1',
    'label_biosource_niveau_2', 'label_ce', 'label_he', 'label_he_effinergie',
    'label_hpe_enr', 'label_hqe', 'label_maison_de_confiance', 'label_maison_de_qualite',
    'label_nf_maison_individuelle', 'label_promotelec', 'label_qualibat', 'label_thpe',
    'plan_local_habitat', 're_2020', 're_2025', 're_seuil_2028',
    
    // Modèles et marques (pour constructions)
    'gamme_modele_maison', 'marque_maison', 'modele_maison',
    
    // Informations financières et juridiques
    'charges_copropriete', 'charges_locatives', 'complement_loyer', 'depot_garantie',
    'frais_agence', 'frais_annexes', 'frais_notaire', 'honoraires_etat_des_lieux',
    'honoraires_location', 'honoraires_negociation', 'honoraires_negociation_vendeur',
    'honoraires_payeurs', 'honoraire_ttc', 'intercabinet_repartition_honoraires',
    'modalites_recuperation_charges_locatives', 'montant_caution_solidaire',
    'pourcentage_honoraires_vendeur', 'prix', 'prix_hors_taxe', 'prix_max', 'prix_min',
    'prix_terrain', 'prix_vendu_net', 'taxe_fonciere', 'taux_tva',
    
    // Locations et baux
    'avec_linge_maison', 'colocation', 'duree_du_bail', 'location_active', 'location_active_nud',
    'loyer_an_est_ht', 'loyer_de_base', 'loyer_est_cc', 'loyer_ht_hc_m2_an', 'loyer_mensuel',
    'loyer_mensuel_cc', 'loyer_mensuel_est_ht', 'loyer_reference_majore', 'meuble',
    'pour_investisseur', 'tarif_hebdo_basse_saison', 'tarif_hebdo_haute_saison',
    'tarif_hebdo_moyenne_saison', 'zone_encadrement_loyer',
    
    // Mandats et relations commerciales
    'date_mandat', 'mandat_echeance', 'mandat_numero', 'mandat_statut', 'mandat_type',
    'vente_intercabinet',
    
    // Offres commerciales
    'date_commercialisation', 'date_compromis', 'date_disponibilite', 'livraison_immediate',
    'offre_date_debut', 'offre_date_fin', 'offre_mentions_legales', 'offre_texte',
    'offre_titre', 'offre_type', 'url_tarifs_publics',
    
    // Partenaires fonciers
    'nom_partenaire_foncier', 'partenaire_foncier_nom', 'partenaire_foncier_prenom',
    'partenaire_foncier_societe', 'partenaire_foncier_telephone', 'prenom_partenaire_foncier',
    'societe_partenaire_foncier', 'telephone_partenaire_foncier',
    
    // Programmes et projets
    'programme_neuf_nom', 'numero_operation',
    
    // Propriétaires
    'proprietaire_adresse1', 'proprietaire_code_postal', 'proprietaire_commentaire',
    'proprietaire_nom', 'proprietaire_tel_bur', 'proprietaire_tel_dom', 'proprietaire_ville',
    
    // Copropriété et ALUR
    'alur_copropriete_plan_de_sauvegarde', 'alur_nb_lots', 'alur_pourcentage_honoraires_ttc',
    'copropriete',
    
    // Viager
    'viager_age_tete1', 'viager_age_tete2', 'viager_rente', 'viager_valeur_venale',
    'viager_vente_a_terme',
    
    // Visites
    'visite_dateVisite', 'visite_horaireVisite', 'visite_nbPersonne',
    
    // Urbanisme et réglementation
    'certificat_urbanisme', 'id_rpls', 'type_jardin',
    
    // Autres champs spécifiques
    'buanderie', 'ebe'
  ])
}

/**
 * Détermine si un champ d'enrichissement doit être inclus selon la configuration
 * @param {string} fieldName - Nom du champ
 * @returns {boolean} - true si le champ doit être inclus
 */
export function shouldIncludeEnrichissementField(fieldName) {
  return DONNEES_ENRICHISSEMENT_CONFIG.allowedFields.has(fieldName)
}
